import { useSelector } from 'react-redux';
import { useIsElectronGateway } from '../../../utils/useIsElectronGateway';

function useMyCustomHook() {
  const userName = useSelector((state) => state.user.name);
  const userPhone = useSelector((state) => state.user.phone);
  const userTable = useSelector((state) => state.user.table);
  const userAddress = useSelector((state) => state.user.address);
  const orderOrigin = useSelector((state) => state.cart.orderOrigin);
  const userPaymentMethod = useSelector((state) => state.user.paymentMethod);
  const userDeliveryMethod = useSelector((state) => state.user.deliveryMethod);
  const isOnlineCommand = useSelector((state) => state.establishment.isOnlineCommand);
  const deliveryRateState = useSelector((state) => state.cart.delivery.rate);
  const isOpen = useSelector((state) => state.establishment.isOpen);
  const isScheduled = useSelector((state) => state.cart.isScheduled);
  const scheduledData = useSelector((state) => state.cart.scheduledData);
  const allowScheduleOrders = useSelector(
    (state) => state.establishment.scheduleOrders.active,
  );
  const allowJustScheduledOrders = useSelector(
    (state) => state.establishment.scheduleOrders.allowJustScheduledOrders,
  );
  const hasValidDaysToScheduleOrders = useSelector(
    (state) => state.establishment.scheduleOrders.hasValidDaysToScheduleOrders,
  );

  const deliveryMethodIsDelivery = userDeliveryMethod.label === 'delivery';
  // No app desktop o atendente fecha o pedido sem escolher "Agora"/"Agendar"
  // nem forma de pagamento. No navegador os dois seguem obrigatorios.
  const isElectronGateway = useIsElectronGateway();
  const hasPaymentMethod = isElectronGateway || !!userPaymentMethod.id;

  const handleCheckIfHaveAllRequiredInfos = () => {
    // Escolher entre "Agora" e "Agendar" e obrigatorio sempre que essa opcao e
    // exibida, e a data do agendamento e obrigatoria sempre que o componente de
    // agendamento e exibido. As duas condicoes espelham o render de
    // Cart/Form/HowToReceive e Cart/Form/ScheduleOrder.
    const hasValidScheduleInfos = () => {
      const showHowToReceive = isOpen
        && !!userDeliveryMethod?.label
        && allowScheduleOrders
        && !allowJustScheduledOrders
        && hasValidDaysToScheduleOrders;

      if (!isElectronGateway && showHowToReceive && isScheduled === null) {
        return false;
      }

      const showScheduledComponent = isScheduled
        || allowJustScheduledOrders
        || (!isOpen && allowScheduleOrders);

      if (!hasValidDaysToScheduleOrders || !showScheduledComponent) {
        return true;
      }

      return !!scheduledData?.deliveryDateTimeStart;
    };

    const hasAllReqInfosForOnlineOrder = () => {
      if (isOnlineCommand) {
        if (
          orderOrigin
          && !userAddress.addressTooFar
          && !userAddress.addressNotFound
          && hasValidScheduleInfos()
        ) {
          if (userDeliveryMethod.name && deliveryMethodIsDelivery && userAddress.street) {
            // !== null because can be 0
            if (deliveryRateState !== null) {
              return true;
            }
            return false;
          }
          return true;
        }
        return false;
      }

      if (
        userName
        && userPhone
        && !userAddress.addressTooFar
        && !userAddress.addressNotFound
        && [13, 14].includes(userPhone?.length)
        && ((deliveryMethodIsDelivery && userAddress.street)
          || (userDeliveryMethod.name && !deliveryMethodIsDelivery))
        && hasPaymentMethod
        && hasValidScheduleInfos()
      ) {
        return true;
      }

      return false;
    };

    const hasAllReqInfosForTableOrder = () => {
      if (userTable) {
        return true;
      }

      return false;
    };

    const hasAllReqInfosForCounterOrder = () => {
      if (isOnlineCommand) {
        if (
          orderOrigin
          && !userAddress.addressTooFar
          && !userAddress.addressNotFound
          && hasValidScheduleInfos()
        ) {
          if (userDeliveryMethod.name && deliveryMethodIsDelivery && userAddress.street) {
            // !== null because can be 0
            if (deliveryRateState !== null) {
              return true;
            }
            return false;
          }
          return true;
        }
        return false;
      }

      if (
        userName
        && !userAddress.addressTooFar
        && !userAddress.addressNotFound
        && ((deliveryMethodIsDelivery && userAddress.street)
          || (userDeliveryMethod.name && !deliveryMethodIsDelivery))
        && hasPaymentMethod
        && ((deliveryMethodIsDelivery
          && userPhone
          && [13, 14].includes(userPhone?.length))
          || !deliveryMethodIsDelivery)
        && hasValidScheduleInfos()
      ) {
        return true;
      }

      return false;
    };

    const hasAllReqInfosForPhoneOrder = () => {
      if (isOnlineCommand) {
        if (
          orderOrigin
          && !userAddress.addressTooFar
          && !userAddress.addressNotFound
          && hasValidScheduleInfos()
        ) {
          if (userDeliveryMethod.name && deliveryMethodIsDelivery && userAddress.street) {
            // !== null because can be 0
            if (deliveryRateState !== null) {
              return true;
            }
            return false;
          }
          return true;
        }
        return false;
      }

      if (
        userName
        && userPhone
        && !userAddress.addressTooFar
        && !userAddress.addressNotFound
        && [13, 14].includes(userPhone?.length)
        && ((deliveryMethodIsDelivery && userAddress.street)
          || (userDeliveryMethod.name && !deliveryMethodIsDelivery))
        && hasPaymentMethod
        && hasValidScheduleInfos()
      ) {
        return true;
      }

      return false;
    };

    if (orderOrigin === 'online') {
      return hasAllReqInfosForOnlineOrder();
    }

    if (orderOrigin === 'table') {
      return hasAllReqInfosForTableOrder();
    }

    if (orderOrigin === 'counter') {
      return hasAllReqInfosForCounterOrder();
    }

    if (orderOrigin === 'phone') {
      return hasAllReqInfosForPhoneOrder();
    }

    return false;
  };

  return handleCheckIfHaveAllRequiredInfos();
}

export default useMyCustomHook;
